export default {
  zh: 'zh-CN',
  tw: 'zh-TW',
  en: 'en-US',
  global: 'en-US'
};
